import { useEffect, useRef } from 'react';
import { Outlet, useParams } from 'react-router';

import { usePatientProfileStream } from '@/features/patientProfileStream';
import { useUploadAssetContext } from '@/features/uploadAsset';

const RECONNECT_DELAY_MS = 2000;

export const PatientLayout = () => {
  const { patientID = '' } = useParams();

  const { reconnectPatientProfileStream } = usePatientProfileStream(patientID);
  const { uploadSessionPullStack } = useUploadAssetContext();

  const previousSessionStatusesRef = useRef<Record<string, string>>({});

  useEffect(() => {
    const previousStatuses = previousSessionStatusesRef.current;

    const hasNewlySucceededSession = Object.entries(
      uploadSessionPullStack,
    ).some(
      ([sessionId, session]) =>
        session.status === 'success' &&
        session.patientID === patientID &&
        previousStatuses[sessionId] !== 'success',
    );

    // Update ref with current statuses
    previousSessionStatusesRef.current = Object.fromEntries(
      Object.entries(uploadSessionPullStack).map(([id, session]) => [
        id,
        session.status,
      ]),
    );

    if (hasNewlySucceededSession) {
      const timeoutId = setTimeout(() => {
        reconnectPatientProfileStream();
      }, RECONNECT_DELAY_MS);

      return () => clearTimeout(timeoutId);
    }
  }, [uploadSessionPullStack, patientID, reconnectPatientProfileStream]);

  return <Outlet />;
};
